import React from 'react';
import {Pagination} from 'tinper-bee';
import './Content.less';
import * as util from '../../../utils';
import HotPackage from './hotPackage';
import FilterArea from './filterArea';
import FilteredPackagesSwitch from './filteredPackagesSwitch';
import FilteredPackages from './filteredPackages';
import PackagesStatistics from './packagesStatistics';
import SearchWrap from '../SearchWrap';

interface FilterMode {
    showMode?: string,
    filterMode?: string,

    [propName: string]: any
}

class Content extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showFilter: true,
            countData: '',
            showMode: 'list', // 展示类型：列表list，格子grid
            filterMode: 'all', // 过滤类型：综合排序all，最新latest，最热hot
            field: 'all', // 领域过滤条件
            type: 'all', // 类型过滤条件
            nexus: 'all', // 类型过滤条件
            innerType: 'all', // 内置分类过滤条件
            page: 1,
            pageSize: 1,
            filterData: null,
            listData: [],
            paginationInfo: {pageNumber: 1}
        };
    }
    seeMDF() {
        this.setState({
            field: 'all',
            type: 'all',
            innerType: 'mdf',
            nexus: 'all',
            page: 1,
            search: undefined
        });
        this.fetchPackages({
            ...{
                field: 'all',
                type: 'all',
                classify: 'mdf',
                nexus: 'all',
                search: undefined,
                page: 1,
            }
        });
    }

    async componentDidMount() {
        const res = await util.get('/home/count');
        this.setState({
            countData: res.data
        });
        const filterRes = await util.get('/home/getFilter');
        this.setState({
            filterData: filterRes.data
        });
        const listRes = await util.get('/package/list');
        this.setState({
            listData: listRes.data.list,
            paginationInfo: listRes.data.pageInfo
        });
    }

    onChange = (value: FilterMode = {}) => {        // 刷新展示的物料数据
        const {showMode, filterMode, field, type, innerType, search, nexus, pageSize} = this.state;
        const data = {
            showMode: value.showMode || showMode,
            filterMode: value.filterMode || filterMode,
            field: value.field || field,
            type: value.type || type,
            innerType: value.innerType || innerType,
            nexus: value.nexus || nexus,
            search: value.search || search,
            page: 1
        };
        this.setState({
            ...data
        }, () => {
            this.fetchPackages({
                ...{
                    type: value.type || type,
                    area: value.field || field,
                    classify: value.innerType || innerType,
                    nexus: value.nexus || nexus,
                    search: value.search || search,
                    pageSize: (pageSize + 1) * 5,
                    pageNumber: 1
                }
            });
        });
    };

    onSearch(value) {
        const {pageSize} = this.state;
        this.setState({
            field: 'all',
            type: 'all',
            innerType: 'all',
            nexus: 'all',
            page: 1,
            search: value
        });
        this.fetchPackages({
            ...{
                field: 'all',
                type: 'all',
                innerType: 'all',
                nexus: 'all',
                search: value,
                pageSize: (pageSize + 1) * 5,
                page: 1,
            }
        });
    }
    dataNumSelect(pageSize) {
        const {field, type, innerType, search, nexus} = this.state;
        this.setState({pageSize});
        this.fetchPackages({
            ...{
                type: type,
                area: field,
                classify: innerType,
                nexus: nexus,
                pageNumber: 1,
                pageSize: (pageSize + 1) * 5,
                search: search,
            }
        });
    }
    pageChange(page) {
        const {field, type, innerType, search, nexus} = this.state;
        this.setState({page});
        this.fetchPackages({
            ...{
                type: type,
                area: field,
                classify: innerType,
                nexus: nexus,
                pageNumber: page,
                search: search,
            }
        });
    }

    fetchPackages = async (obj) => {
        const {filterMode} = this.state;
        this.setState({
            loading: true,
        });
        const data: any = await util.get('/package/list', {
            ...obj,
            hotOrNew: filterMode === 'all' || filterMode === 'hot' ? 'hot' : 'new'
        });
        this.setState({
            listData: data.data.list,
            loading: false,
            paginationInfo: data.data.pageInfo
        });
    };

    render() {
        const {loading = false, pageSize, nexus, paginationInfo = {}, countData, showMode, filterMode, filterData, field, type, innerType, listData, page} = this.state;
        return (
            <React.Fragment>
                <SearchWrap seeMDF={() => this.seeMDF()} onSearch={(e) => this.onSearch(e)}/>
                <div className='home-content-container'>
                    <div className='packages-blocks wrap'>
                        <div className='left'>
                            {/* <FilterArea
                                data={filterData}
                                field={field}
                                type={type}
                                nexus={nexus}
                                innerType={innerType}
                                onClick={this.onChange}
                            /> */}
                            <div className='left-package'>
                                <div className={`shadow-border ${showMode === 'grid' ? 'no-shadow' : ''}`}>
                                    <FilteredPackagesSwitch
                                        showMode={showMode}
                                        filterMode={filterMode}
                                        onChange={this.onChange}
                                    />
                                    <FilteredPackages
                                        showMode={showMode}
                                        data={listData}
                                        loading={loading}
                                    />
                                </div>
                                {loading === false && paginationInfo.count > pageSize ? <Pagination
                                    first
                                    last
                                    prev
                                    next
                                    maxButtons={5}
                                    boundaryLinks
                                    activePage={page}
                                    onSelect={page => this.pageChange(page)}
                                    onDataNumSelect={pageSize => this.dataNumSelect(pageSize)}
                                    showJump={true}
                                    dataNum={pageSize}
                                    total={paginationInfo.count}
                                /> : null}
                            </div>
                        </div>
                        <div className='right'>
                            <PackagesStatistics
                                data={countData}
                            />
                            <HotPackage/>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Content;
